import * as _ from 'lodash-es';
import { ref } from 'vue';
import { acceptHMRUpdate, defineStore } from 'pinia';
import { MenuData } from '@repo/core/models';
import { useDxClientMenu } from '@/utils';

export const useMenuStore = defineStore('menu', () => {
  // utils
  const dxClientMenu = useDxClientMenu();

  // state
  const menus = ref<MenuData[]>([]);

  // actions
  const fetchMenuItems = async () => {
    const result = await dxClientMenu.loadMenuItems();
    menus.value = result;
    return result;
  };

  const findMenuItem = (id: string | undefined) => {
    const pageId = _.split(id, '_')[0];
    return dxClientMenu.findMenuItem(menus.value, pageId);
  };

  const state = { menus };
  const actions = { fetchMenuItems, findMenuItem };

  return { ...state, ...actions };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useMenuStore, import.meta.hot));
}
